import * as THREE from 'three';
import {
  CARD1Web
} from '../CoordUtils.js';

import {BaseDrawer} from "@/drawings3D/modelDrawing/BaseDrawer"
import { LaneDividerLine } from '@/drawings3D/models/LaneDividerLine'
import { LaneDividerLineDrawer } from '@/drawings3D/modelDrawing/LaneDividerLineDrawer'
export class LaneDividerLinesDrawer extends BaseDrawer {
  constructor(totalLaneNum, startStake, endStake, roadStakes, sceneManager, medialDividerWidth, stepFactor){
    super(sceneManager, startStake, endStake, roadStakes);
    this.dividerLineMaterial = new THREE.MeshPhongMaterial({
      map: new THREE.TextureLoader().load("/static/bimroad/textures/guardPoleSurface.jpg")
  });

    var leftEmeDividerLine = new LaneDividerLine(0.15, false, -2, 
      totalLaneNum, startStake, endStake, roadStakes);
    var rightEmeDividerLine = new LaneDividerLine(0.15, false, -1, 
      totalLaneNum, startStake, endStake, roadStakes);

    this.laneDividerLines = new Array();
    if (totalLaneNum >= 2){
      //车道小于4一般都是单向，这里需要改进成可配置
      this.laneDividerLines.push(leftEmeDividerLine);
    }
    this.laneDividerLines.push(rightEmeDividerLine);
    
    for (var i = 0; i < totalLaneNum; i++){
      var laneDividerLine = new LaneDividerLine(0.2, true, i, 
      totalLaneNum, startStake, endStake, roadStakes);
      this.laneDividerLines.push(laneDividerLine);
    }
    roadStakes.map(item=>{
      item.roadElementParams.totalLaneNum = totalLaneNum;
    });
    this.medialDividerWidth = medialDividerWidth;
    this.stepFactor = stepFactor;
  }

  draw(){
        var that = this;
        var laneDividerLines = []; 
        this.laneDividerLines.map(item=>{
            var laneDividerLineDrawer = new LaneDividerLineDrawer(item, this.sceneManager, this.medialDividerWidth, that.stepFactor);
            var mesh = laneDividerLineDrawer.draw();
            if (mesh){
              laneDividerLines.push(mesh);  
            }
            
        });
        return laneDividerLines;     
  }
 
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/LaneDividerLinesDrawer.js